import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=fa4e4f1a&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=js&"
export * from "./table-header.vue?vue&type=script&lang=js&"
import style0 from "./table-header.vue?vue&type=style&index=0&id=fa4e4f1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4e4f1a",
  null
  
)

export default component.exports